import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes } from '../beh-api';
import { useProfile } from '../../shared/hooks/AuthContext';

export interface ConfigurationStepDto {
  configurationStep: ConfigurationStep;
}

export const enum ConfigurationStep {
  CHECKLIST = 'CHECKLIST',
  FITCONNECTCLIENT = 'FITCONNECTCLIENT',
  DESTINATIONS = 'DESTINATIONS',
  DATAMODELS = 'DATAMODELS',
  SENDERCONFIG = 'SENDERCONFIG',
  BUNDID = 'BUNDID',
  LOGO = 'LOGO',
  FOOTER = 'FOOTER',
  FINISH = 'FINISH',
  SUMMARY = 'SUMMARY'
}

export default function useConfigurationStep() {
  const { profile, isTenantAdmin, isLoading: isLoadingProfile } = useProfile();

  const hasGroupAdministration = profile ? isTenantAdmin(profile) : false;

  const {
    data: configurationStep,
    error,
    refetch: mutate,
    fetchStatus
  } = useQuery<ConfigurationStepDto>({
    queryKey: [BehApiRoutes.configurationStep()],
    enabled: hasGroupAdministration
  });

  return {
    configurationStep,
    error,
    mutate,
    isLoading: fetchStatus === 'fetching' || isLoadingProfile
  };
}
